<template>
    <div :class="{'has-danger': (!valid && !busy)}">
        <div class="input-group">
            <input type="text" :value="value" @input="validateSlug" @keydown="keydown" @paste="paste"
                   class="form-control slug-input" />
            <span class="input-group-btn" >
                <button @click.prevent="makeSlug()" class="btn btn-secondary" type="button">Make Slug</button>
             </span>
            <span class="slug-icon">
            <i class="fa fa-refresh" v-if="busy" aria-hidden="true"></i>
            <span v-else>
                <i class="fa fa-check-circle-o text-success" v-if="valid"></i>
                <i v-else class="fa fa-times-circle text-danger"></i>
            </span>
        </span>
        </div>
    </div>
</template>
<style>
.slug-input {
    text-indent: 14px;
}

.slug-icon {
    position: absolute;
    top: 6px;
    left: 10px;
    z-index: 3;
}
</style>
<script>
import axios from 'axios';
import debounce from 'lodash/debounce';

export default {
    props: ['value', 'id', 'lang', 'validationUrl','form','slugFrom'],
    data() {
        return {
            validSlug: '',
            valid: true,
            busy: false,
        };
    },
    methods: {
        validate: debounce(function(slug) {
            axios.get(this.validationUrl, {
                cancelToken: this.source.token,
                params: {
                    lang: this.lang,
                    slug,
                    id: this.id
                }
            }).then(res => {
                if (res.data.valid) {
                    this.validSlug = slug;

                }
                this.valid = res.data.valid;
                this.busy = false;
            }, err => {
                if (err.response.status === 422) {
                    this.valid = false;
                    this.busy = false;
                }
            });
        }, 200),
        makeSlug()
        {
            let sanitized = this.sanitize(this.slugFrom[this.lang]);

            this.form.slug = Object.assign({}, this.form.slug, {
                [this.lang]: sanitized
            });

            if (this.source) {
                this.source.cancel();
            }

            this.source = axios.CancelToken.source();

            this.$emit('input', sanitized);
            this.validate(sanitized);

        },
        validateSlug(e)
        {

            let slug = e.target.value;

            this.$emit('input', slug);

            if (slug === this.value) {
                return;
            }
            if (this.source) {
                this.source.cancel();
            }

            this.source = axios.CancelToken.source();

            this.busy = true;
            this.validate(slug);
        },
        keydown(e) {
            if (e.shiftKey === true) {
                e.preventDefault();
                return false;
            }
            //numeric
            if (e.which >= 65 && e.which <= 90) {
                return true;
            }
            // alpha
            if (e.which >= 48 && e.which <= 57) {
                return true;
            }
            // dash
            const allowed = [8, 9, 46, 37, 38, 39, 40, 189];
            if (allowed.includes(e.which)) {
                return true;
            }

            e.preventDefault();
            return false;
        },
        paste(e) {
            let data = e.clipboardData.getData('Text') || '';
            e.preventDefault();

            let sanitized = this.sanitize(data);
            this.$emit('input', sanitized);
            this.validate(sanitized);
        },

        sanitize(string)
        {
            return string.toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-')
                .replace(/^-+/, '')
                .replace(/-+$/, '');
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/form/SlugInput.vue